import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'
import { FAQ_PAGE } from '../../pg-plus/constants'

type INoShippingMethodsProps = {
    clearAddress: Function
}

const AddressHasNoShippingMethodsContent = ({
    clearAddress,
}: INoShippingMethodsProps) => {
    return (
        <p>
            No delivery options were found for this address. Please{' '}
            <a
                onClick={() => clearAddress()}
                onKeyDown={(e) =>
                    handleEnterPressEvent(e, () => clearAddress())
                }
                tabIndex={0}
                role={'button'}
            >
                enter a different address
            </a>{' '}
            . For more information, see our list of{' '}
            <a href={FAQ_PAGE} id={'frequently-asked-questions'} tabIndex={0}>
                frequently asked questions
            </a>
            .
        </p>
    )
}

export default AddressHasNoShippingMethodsContent
